"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenProcessPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const hooks_1 = require("../../hooks");
const useCurrentUserSelector_1 = require("../../hooks/useCurrentUserSelector");
const InterimScreenTemplate_1 = require("../../templates/InterimScreenTemplate/InterimScreenTemplate");
function InterimScreenProcessPage() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const environment = (0, hooks_1.useAuthType)();
    const currentUser = (0, useCurrentUserSelector_1.useCurrentUserSelector)(currentUserState => currentUserState);
    /**
     * Contains the timeout id for the navigation timeout
     */
    const navigationTimeoutId = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (navigationTimeoutId.current !== null) {
            return;
        }
        if (currentUser !== null && currentUser !== undefined) {
            navigationTimeoutId.current = window.setTimeout(() => {
                navigate(-1);
            }, 1000);
        }
    }, [currentUser, navigate]);
    /**
     * Clear the timeout when the component is unmounted
     */
    (0, react_1.useEffect)(() => {
        return () => {
            if (navigationTimeoutId.current !== null) {
                window.clearTimeout(navigationTimeoutId.current);
                navigationTimeoutId.current = null;
            }
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(InterimScreenTemplate_1.InterimScreenTemplate, { environment: environment, title: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.processingAuth.title), subtitle: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.processingAuth.description), "data-e2e": 'InterimScreenProcessPage_InterimScreenTemplate', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressIndicator, { color: environment === 'sso' ? '#47CFCB' : undefined, "data-e2e": 'InterimScreenProcessPage_ProgressIndicator' }) }));
}
exports.InterimScreenProcessPage = InterimScreenProcessPage;
